export function hasPermission(user, name) {
  return Boolean(user?.permissions?.[name]);
}

export function isAdmin(user) {
  return user?.role === 'admin' || hasPermission(user, 'manage_all_users');
}

export const ROLE_LABELS = {
  admin: 'Администратор',
  owner: 'Владелец',
  curator: 'Хранитель',
  visitor: 'Посетитель',
};

export const ALL_ROLES = [
  { value: 'admin', label: 'Администратор' },
  { value: 'owner', label: 'Владелец' },
  { value: 'curator', label: 'Хранитель' },
  { value: 'visitor', label: 'Посетитель' },
];

export const OWNER_ROLES = [
  { value: 'curator', label: 'Хранитель' },
  { value: 'visitor', label: 'Посетитель' },
];

export function postLoginPath(user) {
  if (isAdmin(user)) return '/admin';
  if (user?.role === 'visitor') return '/artworks';
  return '/';
}
